"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertTeamName = exports.AlertSeverity = void 0;
/**
 * Readable, wire-decoupled alert severity for use in DTOs and persisted
 * config
 *
 */
var AlertSeverity;
(function (AlertSeverity) {
    AlertSeverity["CRITICAL"] = "CRITICAL";
    AlertSeverity["HIGH"] = "HIGH";
    AlertSeverity["MODERATE"] = "MODERATE";
    AlertSeverity["LOW"] = "LOW";
    AlertSeverity["INFO"] = "INFO";
})(AlertSeverity = exports.AlertSeverity || (exports.AlertSeverity = {}));
var AlertTeamName;
(function (AlertTeamName) {
    AlertTeamName["Software"] = "Software";
})(AlertTeamName = exports.AlertTeamName || (exports.AlertTeamName = {}));
